import emojiPattern from 'emoji-regex'
import disallowedCharsRegex from './disallowedCharsRegex'

/*
 * This function receives a message and limits its length and also the amount of '\n' characters.
 * Max length is determined by the `maxLength` property in `options`.
 * Max linefeed characters is determined by the `maxLinefeed` property in `options.
 *
 * returns message string
 */
type Options = {
    maxLength: number
    maxLinefeed: number
}

export default function normalizeGiftmessage(message = '', prevMessage = '', options: Options): string {
    const { maxLength, maxLinefeed } = options

    if (prevMessage.length === maxLength && message.length >= maxLength) {
        return prevMessage
    }

    // restrict emojis
    const emojiRegex = emojiPattern()
    const disallowedCharsRegexPattern = disallowedCharsRegex()
    message = message.replace(emojiRegex, '')
    message = message.replace(disallowedCharsRegexPattern, '')
    // restrict number of lines
    let currentLinefeed = 0
    let i = 0

    while (i < message.length) {
        if (message[i] === '\n') {
            currentLinefeed += 1

            if (currentLinefeed > maxLinefeed) {
                message = message.slice(0, i) + message.slice(i + 1)
                continue
            }
        }

        i += 1
    }

    return message.slice(0, maxLength)
}
